import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  DeleteRecord,
  SuccessAlert,
  URLPRIFIX,
  ErrorAlert,
  baseurl,
} from "../../functions/api";
import axios from "axios";
import { useStore } from "../../Components/StateProvider";
import Filters from "../../Components/Fields/Filters";
import Pagination from "../../Components/Fields/Pagination";
import { getlocal } from "../../functions/localstorage";
import { FaSearch, FaSortAlphaDown, FaSortAlphaDownAlt, FaStar } from "react-icons/fa"; // Import FaStar for the badge icon

const BadgeTaskList = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  
  const queryParams = new URLSearchParams(location.search);
  const user = getlocal("system")?.user || {};
  const { id } = useParams();

  const [activeTab, setActiveTab] = useState("all");
  const [selectedRecords, setSelectedRecords] = useState([]); // State to hold selected records for bulk actions
  const [hasNoRecords, setHasNoRecords] = useState(false); // New state to track if no records are found

  const tablename = "tasks";
  const tableURL = "/badges/getbyuserid/" + id;

  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({
    field: "",
    direction: "asc",
  });
  const [localSearch, setLocalSearch] = useState("");

  const Tablehead = " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[16px] xl:text-[20px] font-bold ";
  const Tablerecord = " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[12px] xl:text-[16px] overflow-hidden";
  const width = "100%";
  const height = "90%";

  const Header = [
    ["Task", "subtask_title"],
    ["Type", "type"],
    ["Approved By", "approved_by"],
    ["Completed Date", "completed_date"],
    ["Badge", "hasBadge"], 
  ];

  const store = useStore();
  const init = {
    filterfield: "all",
    search: "",
    sort: "desc",
    currentpage: 1,
    totalpage: 1,
    pagesize: 20,
  };

  useEffect(() => {
    // store.setmodule("nonlitigation_tasks", init);
    store.setmodule("dashboard",init);
    store.stopLoading();
    store.setheader(tablename + " List");
    store.setvalue("defaultpagesize", init.pagesize);

    GetListview({
      listUrl: tableURL,
      store: store,
      field: queryParams.get("field") || init.filterfield,
      search: queryParams.get("search") || init.search,
      sort: queryParams.get("sort") || init.sort,
      pagesize: queryParams.get("pagesize") || init.pagesize,
    });

    store.setvalue("search", init.search);
    store.setvalue("filterfield", init.filterfield);
    store.setvalue("pagesize", init.pagesize);
  }, [queryParams.get("search"), queryParams.get("field"), id]);

 

  function change(props) {
    store.setvalue("filterfield", props.field);
    store.setvalue("search", props.search);
    store.setvalue("pagesize", props.pagesize || store.getvalue("pagesize"));
    store.setvalue("currentpage", 1);

    GetListview({
      listUrl: tableURL,
      store: store,
      field: props.field,
      search: props.search,
      sort: props.sort,
      page: 1,
      pagesize: props.pagesize || store.getvalue("pagesize"),
    });
  }

  function onpage(page, pagesize = store.getvalue("pagesize")) {
    GetListview({
      listUrl: tableURL,
      store: store,
      field: store.getvalue("filterfield"),
      search: store.getvalue("search"),
      sort: store.getvalue("sort"),
      page: page,
      pagesize: pagesize,
    });
  }

  const statusTabs = store.getvalue("statuscount") || [];

  const handleOnSelect = (itemOrItems, isChecked) => {
    if (Array.isArray(itemOrItems)) {
      if (isChecked) {
        setSelectedRecords([...itemOrItems]);
      } else {
        setSelectedRecords([]);
      }
    } else {
      if (isChecked) {
        setSelectedRecords((prevSelected) => [...prevSelected, itemOrItems]);
      } else {
        setSelectedRecords((prevSelected) =>
          prevSelected.filter((record) => record.id !== itemOrItems.id)
        );
      }
    }
  };

  const handleBulkAssign = (itemsToAssign) => {
    console.log("Bulk Assign these items:", itemsToAssign);
    alert(`Assigning ${itemsToAssign.length} items! (Implement API call here)`);
    setSelectedRecords([]);
    GetListview({
      listUrl: tableURL,
      store: store,
      field: store.getvalue("filterfield"),
      search: store.getvalue("search"),
      sort: store.getvalue("sort"),
      page: store.getvalue("currentpage"),
      pagesize: store.getvalue("pagesize"),
    });
  };

  const handleClickRow = (item) => {
    console.log("Row clicked:", item);
    if (store.getprops("view")) {
      if(item.type_id==11){
      store.navTo(`/${URLPRIFIX}/${tablename}/view/${item.task_id}`);
      }else if (item.type_id==12){
        store.navTo(`/${URLPRIFIX}/litigation/${tablename}/view/${item.task_id}`);
      }
      else{
        store.navTo(`/${URLPRIFIX}/trademark/${tablename}/view/${item.task_id}`);
      }
    }
  };

  const handleSort = (label) => {
    setSortConfig((prev) => ({
      field: label,
      direction:
        prev.field === label && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const records = store.getvalue("list") || [];

  const filteredRecords = records
    .filter((record) =>
      Header.every(([_, label]) => {
        const filterValue = filters[label];
        if (!filterValue) return true;

        let fieldValue = record[label];
        if (label.toLowerCase().includes("date") && fieldValue) {
          const parsed = new Date(fieldValue);
          if (!isNaN(parsed)) fieldValue = parsed.toISOString().split("T")[0];
        } else if (label === "hasBadge") { // Special handling for the "Badge" column
            return filterValue.toLowerCase() === "true" ? fieldValue : !fieldValue;
        }

        return (
          fieldValue &&
          fieldValue.toString().toLowerCase().includes(filterValue.toLowerCase())
        );
      })
    )
    .sort((a, b) => {
      const { field, direction } = sortConfig;
      if (!field) return 0;

      const aVal = (a[field] ?? "").toString().toLowerCase();
      const bVal = (b[field] ?? "").toString().toLowerCase();

      if (aVal < bVal) return direction === "asc" ? -1 : 1;
      if (aVal > bVal) return direction === "asc" ? 1 : -1;
      return 0;
    });

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      handleOnSelect(filteredRecords, true);
    } else {
      handleOnSelect([], false);
    }
  };

  const isAllSelected =
    filteredRecords.length > 0 &&
    selectedRecords.length === filteredRecords.length &&
    filteredRecords.every((record) =>
      selectedRecords.some((sItem) => sItem.id === record.id)
    );

  const isSelected = (item) => selectedRecords.some((sItem) => sItem.id === item.id);

  const selectedField = store.getvalue("filterfield");
  const currentSort = store.getvalue("sort");
   if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 font-inter">
        <div className="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-lg">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#8B5CF6] mb-4"></div>
          <p className="text-lg text-gray-700">Loading ...</p>
        </div>
      </div>
    );
  }
 function GetListview({
    listUrl = "",
    field = "",
    search = "",
    sort = "",
    page = 1,
    count = 10,
    store,
    pagesize = 20,
  }) {
    let token = getlocal("system").token;
    let url = "";
    if (field !== "") url += "&fieldname=" + field;
    if (search !== "") url += "&search=" + search;
    if (sort !== "") url += "&sort=" + sort;
    if (page !== "") url += "&page=" + page;
    if (count !== "") url += "&count=" + count;
    if (pagesize !== "") url += "&pagesize=" + pagesize;
    url = url.substring(1, url.length);
    url = `${baseurl}${listUrl}?${url}`;

    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setLoading(false);
        res = res?.data;
        let count = res?.totalCount;
        let statuscount = res?.statuscount;

        let totalCount = res?.totalCount / pagesize;

        if (totalCount % 1 == 0) {
          totalCount = Math.floor(totalCount);
        } else {
          totalCount = Math.floor(totalCount) + 1;
        }

        store.setvalue("totalpage", totalCount);
        store.setvalue("currentpage", page);
        store.setvalue("pagesize", pagesize);

        // Add a 'hasBadge' property to each task item based on your logic
        // For demonstration, let's assume a task has a badge if its 'approved_by' field is not empty.
        // You'll need to adjust this logic based on your actual data structure and badge criteria.
        const listWithBadges = res?.list?.map(item => ({
          ...item,
          hasBadge: !!item.approved_by // Example logic: if approved_by exists, it has a badge
        }));
        store.setvalue("list", listWithBadges);

        setHasNoRecords(listWithBadges?.length === 0); // Set hasNoRecords based on the list length

        let head = Object.keys(res?.list[0] || []);
        head?.splice(5, 0, "ACTION");
        store.setvalue("header", head);
        store.setvalue("totalrecords", count);
        store.setvalue("statuscount", statuscount);
      })
      .catch((res) => {
        console.error("Error Response", res);
        setHasNoRecords(true); 
        setLoading(false);
      });
  }
  return (
    <div className="grid grid-rows-10 h-full">
      <div className="flex flex-wrap justify-between items-center mb-2 px-2">
        <div className="flex flex-wrap gap-1 max-w-full">
          {statusTabs?.map((tab) => (
            <button
              key={tab.status}
              onClick={() => {
                setActiveTab(tab.status);
                change({
                  field: "status",
                  search: tab.status === "ALL" ? "" : tab.status,
                  pagesize: tab.count,
                  sort: store.getvalue("sort"),
                });
              }}
              className={`text-sm px-3 py-1 rounded-full border-2 transition ${activeTab === tab.status
                  ? "bg-white text-primary border-primary"
                  : "bg-primary text-secondary border-primary"
                }`}
            >
              {tab.status} ({tab.count})
            </button>
          ))}
        </div>
      </div>

      <div className="row-span-9 h-full w-full">
        <div className="py-5 px-[30px] h-full w-full" contentEditable={false}>
          {hasNoRecords ? (
            <div className="flex justify-center items-center h-full text-xl text-gray-500">
              No badges for this user.
            </div>
          ) : (
            <div
              className={`flex overflow-auto`}
              style={{ height: height, width: width }}
            >
              <table className="table-auto w-full h-fit">
                <thead className="sticky top-0 bg-secondary text-left mt-10 border-b">
                  <tr className="px-1">
                    <th className={Tablehead}>S.No.</th>
                    <th className={Tablehead}>
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={isAllSelected}
                      />
                    </th>

                    {Header.map(([name, label], index) => {
                      if (label !== "id" && label !== "select") {
                        return (
                          <th key={index} className={Tablehead}>
                            <div
                              className="flex flex-col cursor-pointer"
                              onClick={() => handleSort(label)}
                            >
                              <div className="flex items-center justify-between">
                                <span>{name}</span>
                                {sortConfig.field === label && (
                                  <span>{sortConfig.direction === "asc" ? "↑" : "↓"}</span>
                                )}
                              </div>
                              {label === "hasBadge" ? (
                                <select
                                  className="px-1 mt-1 rounded-sm text-sm"
                                  value={filters[label] || ""}
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={(e) =>
                                    setFilters((prev) => ({
                                      ...prev,
                                      [label]: e.target.value,
                                    }))
                                  }
                                >
                                  <option value="">All</option>
                                  <option value="true">Yes</option>
                                  <option value="false">No</option>
                                </select>
                              ) : (
                                <input
                                  type={label.toLowerCase().includes("date") ? "date" : "text"}
                                  placeholder={`Filter ${name}`}
                                  className="px-1 mt-1 rounded-sm text-sm"
                                  value={filters[label] || ""}
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={(e) =>
                                    setFilters((prev) => ({
                                      ...prev,
                                      [label]: e.target.value,
                                    }))
                                  }
                                />
                              )}
                            </div>
                          </th>
                        );
                      }
                      return null;
                    })}
                  </tr>
                </thead>

                <tbody>
                  {filteredRecords.map((item, index) => (
                    <tr
                      key={item.id || index}
                      className={
                        "border-b h-8 hover:bg-[#b3b3f5] rounded-xl cursor-pointer " +
                        (item?.error && "bg-red bg-opacity-35 ") +
                        (isSelected(item) ? " bg-blue-100 " : "")
                      }
                    >
                      <td className={Tablerecord}>{index + 1}</td>
                      <td
                        className={
                          Tablerecord + " flex justify-center items-center h-full"
                        }
                      >
                        <input
                          type="checkbox"
                          onChange={(event) => {
                            handleOnSelect(item, event.target.checked);
                          }}
                          checked={isSelected(item)}
                        />
                      </td>

                      {Header.map(([name, label], fieldindex) => {
                        if (label.toLowerCase().includes("date")) {
                          const dateValue = item[label];
                          let displayDate = '---';

                          if (typeof dateValue === 'string' && dateValue) {
                            const [date] = dateValue.split("T");
                            displayDate = date;
                          }

                          return (
                            <td
                              key={fieldindex}
                              className={Tablerecord}
                              onClick={() => {
                                handleClickRow && handleClickRow(item);
                              }}
                            >
                              {displayDate}
                            </td>
                          );
                        } else if (label === "hasBadge") {
                          return (
                            <td
                              key={fieldindex}
                              className={`${Tablerecord} text-center`}
                              onClick={() => {
                                handleClickRow && handleClickRow(item);
                              }}
                            >
                              {item.hasBadge ? <FaStar className="inline text-yellow-500" /> : null}
                            </td>
                          );
                        }
                        else if (label !== "id" && label !== "select") {
                          return (
                            <td
                              key={fieldindex}
                              className={Tablerecord}
                              onClick={() => {
                                handleClickRow && handleClickRow(item);
                              }}
                            >
                              {item[label]?.toString()?.charAt(0)?.toUpperCase() +
                                item[label]?.toString()?.slice(1)}
                            </td>
                          );
                        }
                        return null;
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {!hasNoRecords && selectedRecords.length > 0 && (
            <div className="absolute bottom-4 left-4 flex gap-1 p-2 bg-white text-black shadow-xl rounded-md">
              <span className="text-sm px-3 py-1  mr-2 flex items-center">
                {selectedRecords.length} items selected
              </span>
            </div>
          )}

          {!hasNoRecords && (
            <div className="float-right mr-8 mt-6">
              <Pagination onchange={onpage} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BadgeTaskList;